module.exports = __webpack_public_path__ + "static/img/policies_banner.31876b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/policies_banner.jpg
// module id = 1lxu
// module chunks = 5